import Layout from "./Layout.vue";

export default Layout;